export default __webpack_public_path__ + "static/media/slide2.ce2a0a4c.png";